import axios, { AxiosError } from 'axios';
import { httpErrorHandler } from './httpErrorHandler';

export class HttpError extends Error {
  status: number | undefined;

  originalError: Error | AxiosError;

  constructor(error: unknown, defaultMessage?: string | undefined) {
    super(defaultMessage);
    this.name = 'HttpError';
    this.cause = error;

    this.originalError = error as Error | AxiosError;

    if (axios.isAxiosError(error)) {
      this.status = error.response?.status;
    }

    this.message = httpErrorHandler(this.originalError);
  }
}
